import HttpClient from './httpClient';
import { startLoading, finishLoading } from '../store/actions/uiAction';

export const getData = (dispatch, url, data) => {
    dispatch(startLoading());
    return new Promise((resolve, reject) => {
        HttpClient.get(url, data)
            .then(response => {
                dispatch(finishLoading());
                resolve(response);
            })
            .catch(error => {
                dispatch(finishLoading());
                reject(error);
            });
    });
};

export const getOptionData = (dispatch, url) => {
    return new Promise((resolve, reject) => {
        getData(dispatch, url).then((response) => {
            if (response.status === 200) {
                const obj = response.data;
                const res = obj.map(item => ({
                    Code: item.id,
                    Name: item.name
                }));
                resolve(res);
            }
        }).catch(error => {
            reject(error);
        });
    });
};
